var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dynamic-table" },
    [
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", { staticStyle: { width: "45%" } }, [
                _vm._v("Forma de pago")
              ]),
              _vm._v(" "),
              _c("th", { staticStyle: { width: "10%" } }, [_vm._v("Valor")]),
              _vm._v(" "),
              _c("th", { staticStyle: { width: "10%" } }, [_vm._v("Plazo")]),
              _vm._v(" "),
              _c("th", { staticStyle: { width: "15%" } }, [
                _vm._v("Unidad de tiempo")
              ]),
              _vm._v(" "),
              _c(
                "th",
                { staticClass: "ta-right", staticStyle: { width: "3%" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn-success",
                      attrs: { type: "button" },
                      on: { click: _vm.agregarFormaPago }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.value, function(row, index) {
                return _c("tr", { key: index }, [
                  _c("td", [
                    _c(
                      "div",
                      { staticClass: "select2-field select2--readonly" },
                      [
                        _c("v-select", {
                          attrs: {
                            tooltip:
                              row.selectedFormaPago !== undefined &&
                              row.selectedFormaPago !== null &&
                              row.selectedFormaPago.nombre !== ""
                                ? row.selectedFormaPago.nombre
                                : "Seleccione...",
                            label: "nombre",
                            options: _vm.formasPago,
                            id: "formaPago" + index,
                            placeholder: "Seleccione..."
                          },
                          model: {
                            value: row.selectedFormaPago,
                            callback: function($$v) {
                              _vm.$set(row, "selectedFormaPago", $$v)
                            },
                            expression: "row.selectedFormaPago"
                          }
                        }),
                        _vm._v(" "),
                        _vm.erroresFormulario.hasOwnProperty(
                          "formasPago." +
                            index +
                            ".selectedFormaPago.id_forma_pago"
                        )
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.erroresFormulario[
                                        "formasPago." +
                                          index +
                                          ".selectedFormaPago.id_forma_pago"
                                      ][0]
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.money,
                            id: "valor" + index,
                            placeholder: "$ #,###.##",
                            readonly: ""
                          },
                          nativeOn: {
                            keyup: function($event) {
                              return _vm.$emit("updatedFormaPago")
                            }
                          },
                          model: {
                            value: row.valor,
                            callback: function($$v) {
                              _vm.$set(row, "valor", $$v)
                            },
                            expression: "row.valor"
                          }
                        },
                        [
                          _vm.erroresFormulario.hasOwnProperty(
                            "formasPago." + index + ".valor"
                          )
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.erroresFormulario[
                                          "formasPago." + index + ".valor"
                                        ][0]
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.int,
                            id: "plazo" + index,
                            placeholder: "Plazo de pago",
                            readonly: ""
                          },
                          nativeOn: {
                            keyup: function($event) {
                              return _vm.$emit("updatedFormaPago")
                            }
                          },
                          model: {
                            value: row.plazo,
                            callback: function($$v) {
                              _vm.$set(row, "plazo", $$v)
                            },
                            expression: "row.plazo"
                          }
                        },
                        [
                          _vm.erroresFormulario.hasOwnProperty(
                            "formasPago." + index + ".plazo"
                          )
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.erroresFormulario[
                                          "formasPago." + index + ".plazo"
                                        ][0]
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "div",
                      { staticClass: "select2-field select2--readonly" },
                      [
                        _c("v-select", {
                          attrs: {
                            tooltip:
                              row.unidad_tiempo !== ""
                                ? row.unidad_tiempo
                                : "Seleccione...",
                            id: "unidadTiempo" + index,
                            placeholder: "Seleccione...",
                            options: _vm.tiposUnidad
                          },
                          on: {
                            input: function($event) {
                              return _vm.$emit("updatedFormaPago")
                            }
                          },
                          model: {
                            value: row.unidad_tiempo,
                            callback: function($$v) {
                              _vm.$set(row, "unidad_tiempo", $$v)
                            },
                            expression: "row.unidad_tiempo"
                          }
                        }),
                        _vm._v(" "),
                        _vm.erroresFormulario.hasOwnProperty(
                          "formasPago." + index + ".unidad_tiempo"
                        )
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.erroresFormulario[
                                        "formasPago." + index + ".unidad_tiempo"
                                      ][0]
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "d-flex jc-right gap-10" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-info btn--text-outline",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.editarFormaPago(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-edit" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-danger btn--text-outline",
                          attrs: { disabled: _vm.disabled, type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.eliminarFormaPago(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash-o" })]
                      )
                    ])
                  ])
                ])
              }),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.modelValue.length === 0,
                        expression: "modelValue.length === 0"
                      }
                    ],
                    attrs: { colspan: "5" }
                  },
                  [
                    _c("strong", [
                      _vm._v("No se ha agregado forma de pago alguna.")
                    ])
                  ]
                )
              ])
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("dynamic-table", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isDynamicTableVisible,
            expression: "isDynamicTableVisible"
          }
        ],
        attrs: { title: "Forma de pago", value: _vm.selectedItem },
        on: { close: _vm.closeDynamicTable },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var selectedRow = ref.selectedRow
              return [
                _c(
                  "div",
                  {
                    staticClass: "select2-field",
                    class: { "select2--disabled": _vm.disabled }
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        tooltip:
                          selectedRow.selectedFormaPago !== undefined &&
                          selectedRow.selectedFormaPago !== null &&
                          selectedRow.selectedFormaPago.nombre !== ""
                            ? selectedRow.selectedFormaPago.nombre
                            : "Seleccione...",
                        label: "nombre",
                        options: _vm.formasPago,
                        id: "formaPago",
                        placeholder: "Seleccione..."
                      },
                      model: {
                        value: selectedRow.selectedFormaPago,
                        callback: function($$v) {
                          _vm.$set(selectedRow, "selectedFormaPago", $$v)
                        },
                        expression: "selectedRow.selectedFormaPago"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "formPago" } }, [
                      _vm._v("Forma de pago")
                    ]),
                    _vm._v(" "),
                    _vm.erroresFormulario.hasOwnProperty(
                      "formasPago.selectedFormaPago.id_forma_pago"
                    )
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.erroresFormulario[
                                    "formasPago.selectedFormaPago.id_forma_pago"
                                  ][0]
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "input-field",
                  {
                    attrs: {
                      disabled: _vm.disabled,
                      vMoney: "",
                      format: _vm.money,
                      id: "valor",
                      placeholder: "$ #,###.##"
                    },
                    nativeOn: {
                      keyup: function($event) {
                        return _vm.$emit("updatedFormaPago")
                      }
                    },
                    model: {
                      value: selectedRow.valor,
                      callback: function($$v) {
                        _vm.$set(selectedRow, "valor", $$v)
                      },
                      expression: "selectedRow.valor"
                    }
                  },
                  [
                    _c("span", [_vm._v("Valor")]),
                    _vm._v(" "),
                    _vm.erroresFormulario.hasOwnProperty("formasPago.valor")
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.erroresFormulario["formasPago.valor"][0]
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "input-field",
                  {
                    attrs: {
                      disabled: _vm.disabled,
                      vMoney: "",
                      format: _vm.int,
                      id: "plazo",
                      placeholder: "Plazo de pago"
                    },
                    nativeOn: {
                      keyup: function($event) {
                        return _vm.$emit("updatedFormaPago")
                      }
                    },
                    model: {
                      value: selectedRow.plazo,
                      callback: function($$v) {
                        _vm.$set(selectedRow, "plazo", $$v)
                      },
                      expression: "selectedRow.plazo"
                    }
                  },
                  [
                    _c("span", [_vm._v("Plazo")]),
                    _vm._v(" "),
                    _vm.erroresFormulario.hasOwnProperty("formasPago.plazo")
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.erroresFormulario["formasPago.plazo"][0]
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "select2-field",
                    class: { "select2--disabled": _vm.disabled }
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        tooltip:
                          selectedRow.unidad_tiempo !== ""
                            ? selectedRow.unidad_tiempo
                            : "Seleccione...",
                        id: "unidadTiempo",
                        placeholder: "Seleccione...",
                        options: _vm.tiposUnidad
                      },
                      on: {
                        input: function($event) {
                          return _vm.$emit("updatedFormaPago")
                        }
                      },
                      model: {
                        value: selectedRow.unidad_tiempo,
                        callback: function($$v) {
                          _vm.$set(selectedRow, "unidad_tiempo", $$v)
                        },
                        expression: "selectedRow.unidad_tiempo"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "unidadTiempo" } }, [
                      _vm._v("Unidad de tiempo")
                    ]),
                    _vm._v(" "),
                    _vm.erroresFormulario.hasOwnProperty(
                      "formasPago.unidad_tiempo"
                    )
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.erroresFormulario[
                                    "formasPago.unidad_tiempo"
                                  ][0]
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-698622b5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698622b5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/TablaFormaPago.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-698622b5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/TablaFormaPago.vue
// module chunks = 0